import { render, staticRenderFns } from "./Giglio.vue?vue&type=template&id=b0fae554&scoped=true&"
import script from "./Giglio.vue?vue&type=script&lang=js&"
export * from "./Giglio.vue?vue&type=script&lang=js&"
import style0 from "./Giglio.vue?vue&type=style&index=0&id=b0fae554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fae554",
  null
  
)

export default component.exports